export const createRequestRefreshScheduler = ({
    request,
    applyResult,
    onError,
    delay = 1000,
    debounce = true,
}) => {
    let timeoutId;
    let inFlight = false;
    let trailingRefresh = false;
    let disposed = false;
    let callbacks = [];

    const finishCallbacks = () => {
        const pendingCallbacks = callbacks;
        callbacks = [];
        pendingCallbacks.forEach(callback => callback());
    };

    const scheduleRequest = () => {
        if (!debounce && timeoutId) return;

        clearTimeout(timeoutId);
        timeoutId = setTimeout(run, delay);
    };

    const run = async () => {
        timeoutId = undefined;
        inFlight = true;

        try {
            const result = await request();
            if (!disposed) applyResult?.(result);
        } catch (error) {
            if (!disposed) onError?.(error);
        } finally {
            inFlight = false;
            if (disposed) return;

            if (trailingRefresh) {
                trailingRefresh = false;
                scheduleRequest();
            } else {
                finishCallbacks();
            }
        }
    };

    return {
        schedule(callback) {
            if (disposed) return;
            if (callback) callbacks.push(callback);

            if (inFlight) {
                trailingRefresh = true;
            } else {
                scheduleRequest();
            }
        },

        dispose() {
            disposed = true;
            clearTimeout(timeoutId);
            callbacks = [];
        },
    };
};
